import axios from "axios";
import { FINANCE_FORECAST_API_BASE_URL } from "../constants/general";
import { toast } from "react-toastify";

const FinanceForecastInstance = axios.create({
    baseURL: FINANCE_FORECAST_API_BASE_URL
})

FinanceForecastInstance.interceptors.request.use(
    async (request) => {
        return request;
    },
    (error) => {
        const logData = {
            error, error_message: error?.message, errorRequest: error?.request, errorResponse: error?.response,
        };
        console.error(`FinanceForecastInstance Request Error ${error.message}`, logData);
        toast.error(error?.message)
        return Promise.reject(error);
    },
);

FinanceForecastInstance.interceptors.response.use(
    (response) => {
        console.log(`FinanceForecastInstance response ${response && response.status}`, response);
        return response;
    },
    (error) => {
        console.log(error)
        let errMsg='';
        if(error?.code){
            errMsg+=`${error?.code}: `
        }
        errMsg+=`${error?.message}`;
        toast.error(errMsg);

        return Promise.reject(error);
    },
);

export default FinanceForecastInstance;